import React from "react";

import { useNavigate } from "react-router";

import { BlockProps } from "@companion-core/shared/app/Interfaces/blocks";
import { Button } from "@companion-core/shared/app/Components/Button";

export const PushNotification = ({ stepperGoToPrevious }: BlockProps) => {
  const navigate = useNavigate();

  return (
    <div>
      <Button
        label="Push Notification Placholder, press to go back"
        onClick={() => stepperGoToPrevious?.()}
        testID="push-notification-button-back"
      />
      <Button
        label="Push Notification Placholder, press to go to Homepage"
        onClick={() => navigate("/home")}
        testID="push-notification-button-homepage"
      />
    </div>
  );
};
